import { Skeleton, Grid } from '@mui/material'
import { GridStyled, SkeletonCardStyled, SkeletonStyled, Wrapper } from './skeleton-card.styled'
import { number, oneOfType, shape, string, objectOf } from 'prop-types'
import ArtDirectionWrapper from '../../../particles/art-direction/art-direction-wrapper'

//TODO: missing prop for image/text proportions
//TODO: ChildComponent must be defined outside of the component
const SkeletonCard = ({
	rows,
	columns,
	columnGap,
	rowGap,
	orientation,
	textRowsHeight,
	textRowsNumber,
	skeletonProps,
	responsiveProps,
	breakpoints,
	cardRatio,
}) => {
	return (
		<ArtDirectionWrapper
			responsiveProps={responsiveProps}
			breakpoints={breakpoints}
			ChildComponent={({
				rows: responsiveRows,
				columns: responsiveColumns,
				cardRatio: responsiveCardRatio,
				rowGap: responsiveRowGap,
				columnGap: responsiveColumnGap,
			}) => {
				const ratio = responsiveCardRatio ?? cardRatio
				const numberOfColumns = responsiveColumns ?? columns
				return (
					<Grid container rowSpacing={responsiveRowGap ?? rowGap}>
						{[...Array(responsiveRows ?? rows)].map((el, i) => (
							<Grid key={i} item container columnSpacing={responsiveColumnGap ?? columnGap}>
								{[...Array(numberOfColumns)].map((el, x) => {
									return (
										<GridStyled key={x} item orientation={orientation} xs={12 / numberOfColumns}>
											<SkeletonCardStyled
												variant="rectangular"
												orientation={orientation}
												width="100%"
												{...skeletonProps}
											>
												<div
													style={{
														paddingBottom: ratio ? `${100 / ratio}%` : undefined,
													}}
												/>
											</SkeletonCardStyled>
											{textRowsNumber ? (
												<Wrapper orientation={orientation}>
													{[...Array(textRowsNumber)].map((el, y) => {
														return (
															<SkeletonStyled
																key={y}
																variant="text"
																height={textRowsHeight}
																width={textRowsNumber > 1 && y === textRowsNumber - 1 ? '80%' : '100%'}
																{...skeletonProps}
															/>
														)
													})}
												</Wrapper>
											) : null}
										</GridStyled>
									)
								})}
							</Grid>
						))}
					</Grid>
				)
			}}
		/>
	)
}

SkeletonCard.defaultProps = {
	...Skeleton.defaultProps,
	columns: 1,
	rows: 1,
	columnCount: 1,
	columnGap: '15px',
	rowGap: '15px',
	orientation: 'vertical',
	textRowsNumber: 2,
	textRowsHeight: 25,
	cardRatio: 0.8,
	responsiveProps: { xs: {} },
}

const skeletonProps = {
	rows: number,
	columns: number,
	rowGap: oneOfType([number, string]),
	columnGap: oneOfType([number, string]),
	cardRatio: number,
}

SkeletonCard.propTypes = {
	...Skeleton.propTypes,
	/**
	 * number of columns
	 */
	columns: skeletonProps.columns,
	/**
	 * number of row
	 */
	rows: skeletonProps.rows,
	/**
	 * gap between columns
	 */
	columnGap: skeletonProps.columnGap,
	/**
	 * gap between rows
	 */
	rowGap: skeletonProps.rowGap,
	/**
	 * ratio of card
	 */
	cardRatio: skeletonProps.cardRatio,
	/**
	 * skeleton orientation
	 */
	orientation: string,
	/**
	 * number of skeletons text
	 */
	textRowsNumber: number,
	/**
	 * height of single skeletons text
	 */
	textRowsHeight: number,
	/**
	 * Material Skeleton Props
	 */
	skeletonProps: shape({ ...Skeleton.propTypes }),
	responsiveProps: objectOf(shape(skeletonProps)),
	breakpoints: objectOf(number),
}

export default SkeletonCard
